// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"332c17c2","479":"e3e74a12"}[chunkId] + ".chunk.css";
};